<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0">
    <div v-if="!isApplySuccess">
      <div style="padding: 10px;">
        <img style="width: 100%; " src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230425/user-0/20230425/a1bd4950e71614d8d809ed975938d3a0.jpeg?x-oss-process=style/tb-750"/>
      </div>
      <van-form
          @submit="onSubmit"
          @failed="onFailed"
      >
        <van-cell-group>
          <van-field
              v-if="false"
              readonly
              clickable
              name="area"
              :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
              input-align="right"
              label="地区选择"
              placeholder="点击选择省市区"
              @click="showArea = true"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-area
                :area-list="areaList"
                :value="formData.area"
                @confirm="onAreaConfirm"
                @cancel="showArea = false"
            />
          </van-popup>


          <van-field
              value="12月15日24:00，届时关闭申报通道"
              readonly
              error-message-align="right"
              label="截止时间"
              input-align="right"
              clearable
              placeholder="请输入姓名"
          />

          <van-field
              v-model="formData.name"
              :rules="[{ required: true, message: '请输入姓名' }]"
              error-message-align="right"
              label="姓名"
              input-align="right"
              clearable
              placeholder="请输入姓名"
          />
          <van-field
              v-model="formData.num"
              :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
              error-message-align="right"
              label="身份证"
              input-align="right"
              clearable
              placeholder="请输入身份证号"
          />
          <div class="operate-desc-left" >指导教师或学生信息申报</div>


        </van-cell-group>
        <div class="savebtn">
          <van-button
              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
              style="width: 3rem"
              size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
            提交报名
          </van-button>
        </div>
      </van-form>
    </div>
    <div class="order-success" v-else>
      <div class="icon">
        <img src="../../../assets/images/icon-order-done.png" alt="">
      </div>

      <div class="title">申报成功</div>
    </div>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.order-success {
  text-align: center;
  margin: 20px 0;
}

.order-success .icon {
  background-size: 100%;
  width: 75px;
  height: 75px;
  margin: 20px auto 20px auto;

}
.order-success img {
  width: 90%;
  /*height: 120px;*/
  margin: 10px auto;
}

.order-success .title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  text-align: center;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from "@/components/LoginDialog.vue";

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'DakejianApplyShare',
  components: {
    PicUploader, LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      isApplySuccess: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      formData: {
        baoming_id: 0,
        name: '',
        num: '',
      },
    }
  },
  filters: {},
  mounted() {
    document.title = "大课间展演申报"
    let that = this;
    that.areaList = area;
    that.formData.baoming_id = this.$route.query.baoming_id;
//             this.fetch();
//            }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    getUserDetail() {
      let that = this;
      this.$api.get('/api/user/userPage', {}, (res) => {
        console.log(res)
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
            );
            return false;
          } else {
            // Toast(res.msg);
            this.loginShow = true;
          }
        } else {
          Toast(res.msg)
        }
      })
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.getUserDetail();
      this.loginShow = false;
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
    onQuestion() {
      console.log('onQuestion')
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;

      that.saveLoading = true;

      that.$api.post('/api/zdakejian/applyMember', that.formData, (res) => {
        that.saveLoading = false;
        that.isApplySuccess = true
        Toast.success('申报成功');
        // setTimeout(() => {
        //   rbLink({
        //     name: "DakejianApplySuccess",
        //     query: {
        //       id: res.data.id
        //     }
        //   }, 'replace')
        // }, 500)
      }, (res) => {

        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
            );
            return false;
          } else {
            // Toast(res.msg);
            this.loginShow = true;
          }
        }
        Toast(res.msg);
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

  }
}
</script>



// WEBPACK FOOTER //
// DakejianApplyShare.vue?4deec650